import "../JSONTools/JSONformatter.css";
import "./DBTools.css"
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import { CSVtoSQL } from "../../Services/APIService";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { InputHeaderButtons, OutputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";
import { ReactComponent as CaretDownIcon } from "../../Icons/CaretDown.svg";

const exampleCsv = "id;name;salary\n1;Satheesh;50000\n2;John;60000";

function CSVtoSQLConverter() {
    const [text, setText] = useState(exampleCsv);
    const [result, setresult] = useState("")
    const toolFav = { toolName: 'CSV to SQL', Iconpath: "/FileCodeRaw.svg" };

    const [tableName, setTableName] = useState("employee");
    const [dialect, setDialect] = useState("PostgreSQL");
    const [delimiter, setDelimiter] = useState("Semicolon(;)");

    const [multiRow, setMultiRow] = useState(true);
    const [createTable, setCreateTable] = useState(true);
    const [hasHeader, setHasHeader] = useState(true);
    const [includeColumns, setIncludeColumns] = useState(true);
    const delimeterOptions = ["Comma(,)", "Semicolon(;)", "Tab", "Pipe(|)"];
    const dialectOptions = ["MySQL", "PostgreSQL", "SQLite", "MS SQL Server"];
    const [showDelimiterDropdown, setShowDelimiterDropdown] = useState(false);
    const [showDialectDropdown, setShowDialectDropdown] = useState(false);
    const dialectDropdownRef = useRef(null);
    const delimeterDropdownRef = useRef(null);

    

    
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dialectDropdownRef.current &&
                !dialectDropdownRef.current.contains(event.target)
            ) {
                setShowDialectDropdown(false);
            }
            if(
                delimeterDropdownRef.current &&
                !delimeterDropdownRef.current.contains(event.target) 
            ){
                setShowDelimiterDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const lineCount = text !== "" ? (text || "").split("\n").length : 0;
    const resultLineCount = result !== "" ? (result ?? "").toString().split("\n").length : 0;

    const getDialectValue = (value) => {
        const dialectMap = {
            MySQL: "MYSQL",
            PostgreSQL: "POSTGRES",
            SQLite: "SQLITE",
            "MS SQL Server": "MSSQL"
        };
        return dialectMap[value] || value;
    };

    const getDelimiterValue = (value) => {
        const delimiterMap = {
            "Comma(,)": ",",
            Comma: ",",
            "Semicolon(;)": ";",
            Tab: "\t",
            "Pipe(|)": "|"
        };
        return delimiterMap[value] || value;
    };

    const buildRequestBody = (csvValue = text, tableNameValue = tableName) => ({
        csv: csvValue,
        tableName: tableNameValue,
        dialect: getDialectValue(dialect),
        delimiter: getDelimiterValue(delimiter),
        hasHeader: hasHeader,
        multiRow: multiRow,
        includeColumns: includeColumns,
        generateCreateTable: createTable
    });

    const handleChange = (e) => {
        const value = e.target.value;
        setText(value);
    };

    const generateSQL = async () => {
        try {
            const payload = buildRequestBody();
            const res = await CSVtoSQL(payload);
            setresult(res.data.createTableSql  + "\n\n" + res.data.insertSql);
        } catch (error) {
            console.error("Error generating SQL:", error);
        }
    }



    const pasteExample = () => {
        setText(exampleCsv);
    };

    const handletableNameChange = (value) => {
        setTableName(value);
    }

    const handleImport = (filecontent) => {
        setText(filecontent);
    };
    return (
        <>
            <Col>
                <ToolHeader title="CSV to SQL" description="Convert CSV data into SQL INSERT statements" toolFav={toolFav} />

                <Row >
                    <Col className="sql-toolbar">
                        {/* Table Name */}
                        <div className="SQLDropdownWrapper">
                            <label className="toolbar-label">Table Name</label>

                            <input
                                type="text"
                                value={tableName}
                                onChange={(e) => handletableNameChange(e.target.value)}
                                className="SQLDropdownToggle"
                            />
                        </div>

                        {/* Dialect */}
                        <div className="SQLDropdownWrapper" ref={dialectDropdownRef}>

                            <label className="toolbar-label">DIALECT</label>
                            <button
                                type="button"
                                className="SQLDropdownToggle"
                                onClick={() => setShowDialectDropdown((prev) => !prev)}
                            >
                                <span className="SQLDropdownText">{dialect === "" ? 'Select Dialect' : dialect} <CaretDownIcon /></span>
                            </button>
                            {showDialectDropdown && (
                                <div className="SQLDropdownMenu">
                                    {dialectOptions.map((value) => (
                                        <button
                                            key={value}
                                            type="button"
                                            className="SQLDropdownItem"
                                            onClick={() => {
                                                setDialect(value);
                                                setShowDialectDropdown(false);
                                            }}
                                        >
                                            {value}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="SQLDropdownWrapper" ref = {delimeterDropdownRef}>

                            <label className="toolbar-label">DELIMETER</label>
                            <button
                                type="button"
                                className="SQLDropdownToggle"
                                onClick={() => setShowDelimiterDropdown((prev) => !prev)}
                            >
                                <span className="SQLDropdownText">{delimiter === "" ? 'Select Format' : delimiter} <CaretDownIcon /></span>
                            </button>
                            {showDelimiterDropdown && (
                                <div className="SQLDropdownMenu">
                                    {delimeterOptions.map((value) => (
                                        <button
                                            key={value}
                                            type="button"
                                            className="SQLDropdownItem"
                                            onClick={() => {
                                                setDelimiter(value);
                                                setShowDelimiterDropdown(false);
                                            }}
                                        >
                                            {value}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                        {/* Checkboxes */}
                        <div className="toolbar-options">
                            <label className="checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    checked={hasHeader}
                                    onChange={() => setHasHeader(!hasHeader)}
                                />
                                <span>Has header</span>
                            </label>

                            <label className="checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    checked={multiRow}
                                    onChange={() => setMultiRow(!multiRow)}
                                />
                                <span>Multi-row</span>
                            </label>

                            <label className="checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    checked={createTable}
                                    onChange={() => setCreateTable(!createTable)}
                                />
                                <span>CREATE TABLE</span>
                            </label>

                            <label className="checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    checked={includeColumns}
                                    onChange={() => setIncludeColumns(!includeColumns)}
                                />
                                <span>Include Columns</span>
                            </label>
                        </div>

                        {/* Button */}
                        <button className="ExecuteButton" onClick={generateSQL}>
                            ↻ Generate SQL
                        </button>
                    </Col>
                </Row>

                <Row className='Formatter json-formatter-row'>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Input CSV"
                            value={text}
                            onChange={(e) => handleChange(e)}
                            placeholder="Paste your CSV here..."
                            lineCount={lineCount}
                            headerButtons={
                                <InputHeaderButtons
                                    primaryLabel="Example"
                                    onPrimary={pasteExample}
                                    onClear={() => {
                                        setText("");
                                        setresult("");
                                    }}
                                    onImport={(fileContent) => handleImport(fileContent)}
                                    accept=".csv, text/csv"
                                />
                            }
                            footerLeft={`Characters : ${text.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([text]).size} B`}
                        />
                    </Col>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="SQL Output"
                            value={result ?? ""}
                            placeholder="SQL output will appear here..."
                            lineCount={resultLineCount}
                            readOnly
                            headerButtons={
                                <OutputHeaderButtons
                                    outputText={result ?? ""}
                                    fileName="formatted.sql"
                                    mimeType="application/sql;charset=utf-8"
                                />
                            }
                            footerLeft={`Characters : ${result?.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([result ?? ""]).size} B`}
                        />
                    </Col>
                </Row>
            </Col >
        </>
    )
}

export default CSVtoSQLConverter;
